import React from 'react';
import axios from 'axios';

import { API_PATH_REGISTER } from './constants';

import NewsletterAd from './NewsletterAd';



class RegisterForm extends React.Component {

  constructor(props) {
    super(props);

    this.state = {email: '', hanziType:'simp', testType:'vocab'};

    this.startTheTest = this.startTheTest.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleHanziTypeChange = this.handleHanziTypeChange.bind(this);
    this.handleTestTypeChange = this.handleTestTypeChange.bind(this);
  }

  startTheTest(e) {
    e.preventDefault();

    // Register the user in the database
    axios({
        method: 'post',
        url: `${API_PATH_REGISTER}`,
        headers: {'content-type': 'application/json'},
        data: {email: this.state.email, hanziType: this.state.hanziType, testType: this.state.testType}
      })
    .then(result => {
        // Start the test
        const registrationStatus = result.data.registrationStatus;
        const userId = parseInt(result.data.userId);
        this.props.onStartTheTest(e, registrationStatus, userId, this.state.email, this.state.hanziType, this.state.testType);
      })
    .catch(error => {});
  }

  handleEmailChange(e) {
    this.setState({email: e.target.value});
  }

  handleHanziTypeChange(e) {
    this.setState({hanziType: e.target.value});
  }

  handleTestTypeChange(e) {
    this.setState({testType: e.target.value});
  }

  render() {
    const error = this.props.error;
    let errorMessage;
    if(error === 'invalidEmail') errorMessage = <p className="hsk-error">Your email is invalid, please try again.</p>
    else if(error === 'connectionError') errorMessage = <p className="hsk-error">Connection error, please try again later.</p>
    else if (error === 'emptyEmail') errorMessage = <p className="hsk-error">Please enter your email address.</p>
    return (
      <div className="container row">
        <form className="form-signin">
          <div className="text-center mb-4">

            <h1 className="hsk-headline">
              How many
              <span className="gradient-color">
                {this.state.testType==='vocab' ? ' words ' : this.state.testType==='hanzi' ? ' characters ' : ' chengyu '}
              </span>
              do I know in Chinese?
            </h1>

            <div className="hsk-rule"><span>◆</span></div>

            <div className="hsk-start">

              <h5>I want to test my</h5>
              <div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" name="testType" value="vocab" id="vocab" required
                    checked={this.state.testType==='vocab'}
                    onChange={this.handleTestTypeChange}
                  />
                  <label className="form-check-label" htmlFor="vocab">Vocabulary</label>
                </div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" name="testType" value="hanzi" id="hanzi" required
                    checked={this.state.testType==='hanzi'}
                    onChange={this.handleTestTypeChange}
                  />
                  <label className="form-check-label" htmlFor="hanzi">Characters</label>
                </div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" name="testType" value="chengyu" id="chengyu" required
                    checked={this.state.testType==='chengyu'}
                    onChange={this.handleTestTypeChange}
                  />
                  <label className="form-check-label" htmlFor="chengyu">Chengyu</label>
                </div>
              </div>

              {errorMessage}

              <div className="form-label-group">
                <input type="email" name="email" id="email" placeholder="Email" className="form-control"
                        value={this.state.email} onChange={this.handleEmailChange} required autoFocus />
                <label htmlFor="email">Email</label>
              </div>

              <div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" name="hanziType" value="simp" id="simp" required
                    checked={this.state.hanziType==='simp'}
                    onChange={this.handleHanziTypeChange}
                  />
                  <label className="form-check-label" htmlFor="simp">Simplified</label>
                </div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" name="hanziType" value="trad" id="trad" required
                    checked={this.state.hanziType==='trad'}
                    onChange={this.handleHanziTypeChange}
                  />
                  <label className="form-check-label" htmlFor="trad">Traditional</label>
                </div>
              </div>

              <button className="btn btn-lg btn-primary btn-block btn-startthetest" onClick={this.startTheTest}>Start the test</button>

            </div>

            <div style={{marginTop:'20px'}}>
            <NewsletterAd />
            </div>

            <div className="hsk-seo">
              <h5>I built this test because I needed it myself</h5>
              <p>
                I{"'"}m Pierre. I started learning Mandarin at twelve, passed the HSK 4 exam, then barely
                touched Chinese for years while I studied maths and physics. When I picked it up again I had
                no idea what I still knew, and nothing I could find online would tell me. So I built the test
                I was looking for, and I have been improving it ever since.
              </p>
              <p>
                It adapts as you go: every answer changes the next question, so a few minutes of honest
                answers is enough to estimate your Chinese vocabulary size and place you on the HSK and
                TOCFL scales.
              </p>
              <ul>
                <li>Your Mandarin level on all four scales: <em>HSK 2.0</em>, <em>HSK 3.0</em>, the new <em>HSK 3.1</em> and <em>TOCFL</em></li>
                <li>How many words and characters you actually know, not just a band</li>
                <li>The only online test for chengyu ({this.state.hanziType==='trad' ? '成語' : '成语'}), the Chinese idioms</li>
                <li>Simplified or traditional characters, whichever you learn</li>
                <li>Free, no account needed, and your results in a few minutes</li>
              </ul>
              <p>
                Thousands of learners take it every month. If it is useful to you, I write a free weekly
                grammar newsletter too.
              </p>
            </div>
            
          </div>
        </form>
      </div>
    );
  }
}


export default RegisterForm
